export const reportConstants = {
  USER_INFO: 'USER_INFO',
  REPORT_DATA: 'REPORT_DATA'
};
